/**
 * Authentication translations (OIDC-first)
 */

import { LANGUAGES } from '../config';

export const authTranslations = {
  [LANGUAGES.EN]: {
    login: 'Login',
    loginTitle: 'Login',
    loginError: 'Login error',
    loggingIn: 'Signing you in',
    oidcPasswordManagedByProvider: 'Password and account security are managed by the identity provider (Keycloak).'
  },
  [LANGUAGES.FR]: {
    login: 'Connexion',
    loginTitle: 'Connexion',
    loginError: 'Erreur de connexion',
    loggingIn: 'Connexion en cours',
    oidcPasswordManagedByProvider: 'Le mot de passe et la securite du compte sont geres par le fournisseur d identite (Keycloak).'
  }
};
